import $ from "jquery";
import Menu from "DMS/Seed/Seed.Menu";
import { resizeScreen } from "DMS/Utils/resizeScreen";
import { checkRequiredFields } from "DMS/Utils/requiredField";
import { decodeParam } from "DMS/Utils/parameter";
import { destroyGrid } from "DMS/Controllers/kendoController";
import { editPanel } from "DMS/Controllers/smartController";
class Tab {
    constructor() {
        // Nom du module courant
        this.CurrentModule = 0;
        this.Module = 0;
        // Onglet actuel
        this.cTab = 0;
        // Compteur d'identifiant des onglets
        this.iTab = 0;
        this.aTab = [];
        // Tableau des fonctions à lancer
        this.aCallback = [];
        // Onglet parent d'un onglet
        this.aParent = [];
        // Tableau d'onglet Children pour un Onglet
        this.aChild = [];
        // Tableau des modules
        this.aModule = [];
        // Identifiant de l'onglet actif par Module
        this.aActive = [];
        // Ligne sélectionnée et ouverte
        this.focusElementChildNumber = 0;
        // To get in memory the opened panel
        this.aExpanded = [];
        this.aFocused = [];
        this.aOffset = [];
        this.aScroll = [];
        this.aOrder = [];
    }
    // Set Offset to make a scollTo in non-SM form - based on scrollBar position
    SetElementPosition(selectedElement) {
        var topOffset = $(document).scrollTop();
        this.SetOffset(topOffset);
    }
    // Execute the scrollTo in non-SM form
    GoToPosition() {
        let topOffset = this.GetOffset();
        if (topOffset) {
            window.scrollTo(0, topOffset);
        }
    }
    // Method to set the offset in SM mode, depending on
    // which elem got focused
    SetElementChildNumber(myPanel, isFromForm, specialTreatment, inputRefresh, isASignature) {
        if (isFromForm) {
            if (!specialTreatment) {
                var childCounterFromForm = $(myPanel).parent().parent().index();
                this.SetOffset(childCounterFromForm);
            }
            else {
                if (isASignature === true)
                    var childCounterFromForm = $(myPanel).parent().parent().parent().index();
                else
                    var childCounterFromForm = $(myPanel).parent().parent().parent().parent().index();
                if (inputRefresh === undefined)
                    this.SetOffset(childCounterFromForm - 1);
                else
                    this.SetOffset(childCounterFromForm);
            }
        }
        else {
            var childCounterFromList = $(myPanel).index();
            if (specialTreatment) {
                this.SetOffset(childCounterFromList - 1);
            }
            else {
                this.SetOffset(childCounterFromList + 1);
            }
        }
    }
    // Execute a scrollTo or go into the form in SM mode -if n is
    // even, scrollTo in list - if odd, return back into the form
    GetElementInFrame(n) {
        if (((n & 1) === 0) && (n >= 0)) {
            var n = n + 1;
            let backId = this.GetFrame().find('#panel-group').children(':nth-child(' + n + ')').attr("id");
            if (typeof backId !== 'undefined') {
                let topOffset = $('#' + backId).offset().top;
                let panelHeight = $('#' + backId).innerHeight();
                let valueToScroll = topOffset - panelHeight;
                window.scrollTo(0, valueToScroll);
            }
        }
        else if (((n & 1) === 1) && (n >= 0)) {
            editPanel(n, true);
        }
        else {
            window.scrollTo(0, 0);
        }
    }
    GetCurrentTab() {
        if (typeof this.cTab === "undefined" || $(this.cTab).length === 0) {
            const $tab_content = $("[id^='tab_']:visible");
            if ($tab_content.length !== 0) {
                const $all_tab_content = $tab_content.closest("div[id$='_content']");
                const $all_tab_container = $all_tab_content.siblings("ul[id$='_tab']");
                const tabIndex = $tab_content.attr('id').split('_')[1];
                this.cTab = $all_tab_container.children("li[id='" + tabIndex + "']");
            }
            else {
                this.cTab = $tab_content;
            }
        }
        return this.cTab;
    }
    GetCurrentTabID() {
        return this.GetCurrentTab().attr("id");
    }
    /**
     * Associer une fonction à un élément.
     * @param pFunction Fonction à associer
     */
    SetCallback(pFunction) {
        this.aCallback[this.GetCurrentTabID()] = pFunction;
    }
    GetCallback() {
        if (this.aCallback[this.GetCurrentTabID()]) {
            this.aCallback[this.GetCurrentTabID()]();
        }
    }
    /**
     * Associer un texte à un onglet
     * @param pLabel Texte à afficher
     */
    SetText(pLabel) {
        let textToDecode = decodeParam(pLabel);
        this.GetCurrentTab().find("a").text(textToDecode);
    }
    /**
     * Recharger un onglet
     */
    Reload() {
        this.GetCallback();
    }
    SetExpanded(ExpandedID) {
        this.aExpanded[this.GetCurrentTabID()] = ExpandedID;
    }
    GetExpanded() {
        return this.GetFrame().find("#" + this.aExpanded[this.GetCurrentTabID()]);
    }
    SetFocused(FocusedID) {
        this.aFocused[this.GetCurrentTabID()] = FocusedID;
    }
    GetFocused() {
        return this.GetFrame().find("#" + this.aFocused[this.GetCurrentTabID()]);
    }
    SetOffset(Offset) {
        this.aOffset[this.GetCurrentTabID()] = Offset;
    }
    GetOffset() {
        return this.aOffset[this.GetCurrentTabID()];
    }
    SetScroll(ScrollTop) {
        this.aScroll[this.GetCurrentTabID()] = ScrollTop;
    }
    GetScroll() {
        return this.aScroll[this.GetCurrentTabID()];
    }
    SetOrder(OrderBy) {
        this.aOrder[this.GetCurrentTabID()] = OrderBy;
    }
    GetOrder() {
        if (!this.aOrder[this.GetCurrentTabID()])
            return "";
        return this.aOrder[this.GetCurrentTabID()];
    }
    /**
     * Obtenir l'onglet père
     * @returns L'onglet père
     */
    GetParent() {
        return this.aParent[this.GetCurrentTabID()];
    }
    /**
     * Obtenir un tableau d'onglet fils
     * @returns Tableau d'onglet fils
     */
    GetChild() {
        return this.aChild[this.GetCurrentTabID()];
    }
    /**
     * Supprimer les onglets enfants d'un Onglet père
     * @param TabID Identifiant de l'onglet père
     */
    RemoveChildren(TabID) {
        if (this.aChild[TabID]) {
            let Children = this.aChild[TabID].slice(0);
            // Tableau d'onglet enfants
            if (Children) {
                // Supprimer tous les enfants des enfants
                Children.forEach((Child) => {
                    let id = $(Child).attr("id");
                    this.RemoveChildren(id);
                    this.RemoveNode(id);
                });
                delete this.aChild[TabID];
            }
        }
    }
    /**
     * Montrer les onglets enfants  (classe => couleur)
     */
    ShowChildren() {
        let children = this.GetChild();
        if (children) {
            children.forEach((Child) => {
                $(Child).find("a").addClass("Seed_Tab_Child");
            });
        }
    }
    /**
    * Montrer l'onglet parent (classe => couleur)
    */
    ShowParent() {
        let parent = this.GetParent();
        if (parent)
            parent.find("a").addClass("Seed_Tab_Parent");
    }
    /**
    * Montrer l'onglet actuel (classe => couleur)
    */
    ShowActive() {
        this.GetCurrentTab().find("a").addClass("Seed_Tab_Active");
    }
    /**
    * Supprimer les styles des onglets
    */
    ClearStyle() {
        $(".Seed_Tab_Active").removeClass("Seed_Tab_Active");
        $(".Seed_Tab_Parent").removeClass("Seed_Tab_Parent");
        $(".Seed_Tab_Child").removeClass("Seed_Tab_Child");
    }
    /**
    * Obtient le corps lié à l'onget courant
    */
    GetFrame() {
        return $("#tab_" + this.GetCurrentTabID());
    }
    /**
     * Ajouter un onglet
     */
    AddTab() {
        this.ClearStyle();
        if (this.GetCurrentTab()) {
            if ((this.aModule[this.GetCurrentTabID()]) === this.CurrentModule) {
                // SET CURRENT AS PARENT
                this.aParent[this.iTab] = this.GetCurrentTab();
                this.aParent[this.iTab].find("a").addClass("Seed_Tab_Parent");
            }
        }
        this.cTab = $("<li></li>");
        this.cTab.attr("id", this.iTab);
        if (this.GetParent()) {
            // SET NEW TAB AS CHILD OF PARENT
            if (!this.aChild[this.GetParent().attr("id")]) {
                this.aChild[this.GetParent().attr("id")] = new Array();
            }
            this.aChild[this.GetParent().attr("id")].push(this.cTab);
        }
        var Link = $("<a class='Seed_Tab Seed_Tab_Active' id='link_" + this.iTab + "'></a>");
        // Click : refresh des onglets (changement d'onglet ou reclik)
        Link.click((event) => {
            if (event.button !== 1)
                this.linkClick(event.currentTarget, false);
        });
        this.cTab.append(Link);
        // Ajout d'un bouton Close si le Module contient déjà un onglet
        if (this.aActive[this.CurrentModule] !== null) {
            var Close = $('<div class="Seed_Tab_Close" href="javascript:">X</div>');
            // Fermeture de l'onglet : Suppression d'éléments
            this.cTab.mouseup((event) => {
                if (event.button === 1) {
                    this.Close($(event.currentTarget).attr("id"));
                    return false;
                }
            });
            Close.click((event) => this.Close($(event.currentTarget).parent().attr("id")));
            //Link.append(Close);
            this.cTab.append(Close);
        }
        // Association de l'onglet avec le Module
        this.aModule[this.iTab] = this.CurrentModule;
        this.aActive[this.CurrentModule] = this.iTab;
        // Ajout de l'onget à l'affichage
        $("#" + this.CurrentModule + "_tab").append(this.cTab);
        // Construction du contenu
        var TabContent = $("<div id='tab_" + this.iTab + "'> </div>");
        // Cacher tous les contenus lié au Module
        $("#" + this.CurrentModule + "_content")
            .find(".tab_content").hide();
        // Ajouter le nouveau contenu
        $("#" + this.CurrentModule + "_content").append(TabContent);
        // Désigner ce contenu comme contenu
        TabContent.addClass('tab_content');
        // Incrément du compteur général
        this.iTab++;
    }
    /**
     * Afficher le module demandé
     * @param {string} pModuleName Nom du module
     * @param {string} pTitre Titre de l'onglet
     */
    ShowModule(pModuleName, pTitre, isDefaultAction) {
        // On cache le module courant s'il existe
        if (this.CurrentModule !== 0) {
            $("#" + this.CurrentModule + "_frame").hide();
        }
        if (isDefaultAction !== true && pModuleName !== "accueil") {
            // @todo : provoque une dépendance cyclique
            Menu.Clear(pModuleName);
        }
        // Creation pModuleName_frame
        if ($("#" + pModuleName + "_frame").length === 0) {
            var frame = $("<div></div>");
            frame.attr("id", pModuleName + "_frame");
            $("#tdcontent").append(frame);
            var rowOnglet = $("<ul></ul>");
            rowOnglet.attr("id", pModuleName + "_tab");
            rowOnglet.attr('class', 'nav nav-pills ongletModule navbar-fixed-top');
            frame.append(rowOnglet);
            var content = $("<div></div>");
            content.attr('id', pModuleName + '_content');
            content.attr('class', 'tab-pane fade active in container-fluid the-content');
            frame.append(content);
        }
        else {
            this.cTab = $("#" + this.aActive[pModuleName]);
            this.ClearStyle();
            this.ShowActive();
            this.ShowParent();
            this.ShowChildren();
            this.Reload();
        }
        // On affiche le nouveau module
        $("#" + pModuleName + "_frame").fadeIn("slow");
        // Module courant = Module
        this.CurrentModule = pModuleName;
        resizeScreen();
    }
    /**
     * Recherche d'un noeud par identifiant et par nom
     * @param {int} pId Identifiant
     * @param {string} pNodeName Nom
     */
    SearchNode(pId, pNodeName) {
        if (document.getElementById("tab_" + this.GetCurrentTabID()) == null) {
            console.error("Cas imposible, #tab_" + this.GetCurrentTabID() + " not found");
        }
        var divlist = document.getElementById("tab_" + this.GetCurrentTabID())
            .getElementsByTagName(pNodeName);
        var length = divlist.length;
        for (var i = 0; i < length; i++) {
            if (divlist[i].id === pId) {
                return divlist[i];
            }
        }
        return null;
    }
    RemoveNode(idTab) {
        var Parent = this.aParent[idTab];
        $("#tab_" + idTab).remove();
        $('li#' + idTab).remove();
        delete this.aCallback[idTab];
        delete this.aModule[idTab];
        delete this.aParent[idTab];
        if (typeof Parent != "undefined") {
            var idParent = Parent.attr("id");
            var Children = this.aChild[idParent];
            if (Children) {
                // Supprimer tous les enfants des enfants
                var count = Children.length;
                for (var i = 0; i < count; i++) {
                    var Child = Children[i];
                    if (Child) {
                        var idChild = Child.attr("id");
                        if (idChild === idTab) {
                            //                            delete Child;
                            this.aChild[idParent].splice(i, 1);
                        }
                    }
                }
            }
            if (this.aChild[idParent].length === 0) {
                delete this.aChild[idParent];
            }
        }
        else {
            Children = "undefined";
        }
    }
    Close(idTab) {
        if (typeof idTab === "undefined") {
            // onglet courant
            var CurrentTab = this.GetCurrentTab();
            idTab = CurrentTab.attr("id");
        }
        if (!checkRequiredFields(idTab)) {
            return false;
        }
        // Suppression des onglets enfants
        this.RemoveChildren(idTab);
        // Onglet parent
        var Parent = this.aParent[idTab];
        // Onglet courant = onglet père
        var newCTab;
        if (this.GetCurrentTabID() === idTab) {
            this.cTab = Parent;
        }
        else {
            newCTab = Parent;
        }
        // Menage
        destroyGrid(idTab);
        this.RemoveNode(idTab);
        // Verification du CurrentTab
        var idCurrent = this.GetCurrentTabID();
        if ($("#tab_" + idCurrent).length === 0) {
            this.cTab = Parent;
        }
        // Style
        this.ClearStyle();
        this.ShowActive();
        this.ShowParent();
        this.ShowChildren();
        $("#tab_" + this.GetCurrentTabID()).show();
        this.Reload();
    }
    CheckArrays() {
        var result = true;
        // aParent
        var count = this.aParent.length;
        for (var i = 0; i < count; i++) {
            var elem = this.aParent[i];
            if (elem) {
                if ($('[id^=link_' + i + ']').length === 0) {
                    result = false;
                    console.log('Check NOK : aParent index : ' + i);
                }
                var id = $(elem).attr('id');
                if ($('[id^=link_' + id + ']').length === 0) {
                    result = false;
                    console.log('Check NOK : aParent contenu :' + i + ', ' + id);
                }
            }
        }
        // aCallback
        var count = this.aCallback.length;
        for (var i = 0; i < count; i++) {
            elem = this.aCallback[i];
            if (elem) {
                if ($('[id^=link_' + i + ']').length === 0) {
                    result = false;
                    console.log('Check NOK : aCallback index : ' + i);
                }
            }
        }
        // aChild
        var count = this.aChild.length;
        for (var i = 0; i < count; i++) {
            elem = this.aChild[i];
            if (elem) {
                if ($('[id^=link_' + i + ']').length === 0) {
                    result = false;
                    console.log('Check NOK : aChild index : ' + i);
                }
                var nbChild = elem.length;
                for (var j = 0; j < nbChild; j++) {
                    var child = elem[j];
                    if (child) {
                        var id = $(child).attr('id');
                        if ($('[id^=link_' + id + ']').length === 0) {
                            result = false;
                            console.log('Check NOK : aChild contenu : ' + i + ', ' + id);
                        }
                    }
                }
            }
        }
        var link = $('[id^=link_]');
        var count = link.length;
        for (var i = 0; i < count; i++) {
            var id = $(link[i]).attr('id').substring(1, -1);
            // aCallback
            if (typeof this.aCallback[id] === "undefined") {
                console.log('Check NOK : aCallback existe pas : ' + id);
            }
            // aParent
            if (typeof this.aParent[id] === "undefined") {
                console.log('Check NOK : aParent existe pas : ' + id);
            }
        }
        return result;
    }
    /**
     * Affiche ou cache des element de la page selon les valeurs des champs du formulaire
     * Les valeurs des attributs 'data-visible' qui déterminent l'affichage ou non
     * du champ correspondant du formulaire sont les chaines de la colonne visiblecontext
     * de la table yinterface
     * Les valeurs '$_VAL[nomColonne]' de la chaine sont remplacées par les valeurs
     * des colonnes nomColonne du formulaire
     * @param {object} pTargetJqueryObj Object jquery construit autour du dom element
     * correspondant à l'onglet ou à la popup courant (qui contient le formulaire)
     */
    SetVisibility(pTargetJqueryObj = null) {
        pTargetJqueryObj = (pTargetJqueryObj !== null ? pTargetJqueryObj : this.GetFrame());
        pTargetJqueryObj.find('[data-visible]').each(function () {
            var $this = $(this);
            var currentElmtId = $this.attr('id');
            // if the element is a section, a link refers to it in the sidebar
            var $sectionLink = (typeof currentElmtId !== 'undefined' && currentElmtId.startsWith('anchor-section-') ? pTargetJqueryObj.find("[href^='#" + currentElmtId + "']") : null);
            // remplacement de chaque occurence de $_VAL[nomColonne]
            // par l'instruction donnant la valeur de l'element nomColonne du formulaire
            var visibleContext = $this.attr('data-visible').replace(/\$_VAL\[(.*?)\]/g, function (matchedStr, capturedStr) {
                return 'pTargetJqueryObj.find("[id^=\'' + capturedStr + '\']").val()';
            });
            if (eval(visibleContext)) {
                $this.show();
                // showing the link from the sidebar if the element is a section
                if ($sectionLink !== null) {
                    $sectionLink.show();
                }
            }
            else {
                $this.hide();
                // hiding the link from the sidebar if the element is a section
                if ($sectionLink !== null) {
                    $sectionLink.hide();
                }
            }
        });
    }
    linkClick(elem, noReload) {
        var tempId = this.GetCurrentTabID();
        var tempOffset = 0;
        this.cTab = $(elem).parent();
        this.ClearStyle();
        this.ShowActive();
        this.ShowParent();
        this.ShowChildren();
        this.aActive[this.CurrentModule] = this.cTab.attr("id");
        if (typeof this.GetOffset() !== 'undefined'
            || this.GetOffset() >= 0) {
            var clickedTabId = this.GetCurrentTabID();
            if (tempId === clickedTabId) {
                tempOffset = this.SetOffset(this.GetOffset() - 1);
            }
            else {
                tempOffset = this.SetOffset(this.GetOffset());
            }
        }
        $("#" + this.CurrentModule + "_content").find(".tab_content").hide();
        $("#tab_" + this.cTab.attr("id")).show();
        if (noReload) {
            return true;
        }
        this.Reload();
        this.GetElementInFrame(tempOffset);
        this.GetFrame().find('[id^=listSearch]').show();
    }
}
;
export default new Tab();
//# sourceMappingURL=Seed.Tab.js.map